import React from 'react'
import RegisterComponent from './Component/RegisterComponent'
import NavBar from '../LandingPage/Components/NavBar'
import Footer from '../LandingPage/Components/Footer'

function Register() {
    return (
        <div>
            <NavBar />
            <RegisterComponent />
            <Footer />
        </div>
    )
}

export default Register